import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable()
export class NeedLogin  {  
  constructor(private _router: Router) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const identity = JSON.parse(localStorage.getItem('login'));
    if (identity) { return true; }
    // si no puede acceder vuelve al home
    this._router.navigate(['/home']);
    return false;        
  }
}
